Uint8ClampedArrayPrototype